import { AxiosInstance } from "axios";

import authHeader from './auth_header';
import getAxiosInstance from "./axios_instance";


const ApiPath = "/api/address_book";

class AddressBookService {
    private instance: AxiosInstance;
    private readonly navigate: any

    constructor(navigate: any) {
        this.instance = getAxiosInstance(navigate);
        this.navigate = navigate;
    }

    async register(data: any) {
        const headers = authHeader(this.navigate);
        return await this.instance.post(ApiPath, data, { headers });
    }

    async inquiry() {
        const headers = authHeader(this.navigate);
        return await this.instance.get(ApiPath, { headers });
    }

    async modify(id: number, data: any) {
        const headers = authHeader(this.navigate);
        return await this.instance.put(`${ApiPath}/${id}`, data, { headers });
    }

    async delete(id: number) {
        const headers = authHeader(this.navigate);
        await this.instance.delete(`${ApiPath}/${id}`, { headers });
    }
}

export default AddressBookService;